/**
 * Login Selectors
 *
 * Memoized selectors for extracting authentication data from the Redux store.
 * Uses reselect for performance optimization (avoids unnecessary re-renders).
 */
import { createSelector } from 'reselect';

/** Base selector - extracts the login slice from the root state */
const selectLogin = (state: any) => state.login;

/** Selects the full login response (user data, status, JWT token, etc.) */
export const selectLoginResponse = createSelector([selectLogin], (login) => login.loginResponse);

/**
 * Extracts the JWT token from the login state.
 * Used by api.utils.tsx to attach Bearer token to all authenticated API requests.
 * Returns an object with an empty jwtToken string if user is not authenticated.
 */
export const getLoginObjDetails = createSelector([selectLogin], (login) => {
	let loginObj: any = {
		jwtToken: '',
	};
	if (login?.loginResponse) {
		const { jwtToken } = login.loginResponse;

		loginObj = {
			jwtToken,
		};
	}

	return loginObj;
});
